const PREFIX = 'ROLES_NOT_CHECKED_IN_'
export const ROLES_NOT_CHECKED_IN = {
  FETCH_REQUEST: `${PREFIX}FETCH_REQUEST`,
  FETCH_SUCCESS: `${PREFIX}FETCH_SUCCESS`,
  FETCH_FAILURE: `${PREFIX}FETCH_FAILURE`,
  CLEAR: `${PREFIX}CLEAR`
}
